import { render, staticRenderFns } from "./flex-col-content.vue?vue&type=template&id=2a8ce69c&"
var script = {}
import style0 from "./flex-col-content.vue?vue&type=style&index=0&id=2a8ce69c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports